"use client";

import React from "react";
import styles from "./styles.module.scss";

interface IndicatorProps {
  pullDistance: number;
  pullState: "idle" | "pulling" | "ready" | "refreshing" | "returning";
  threshold: number;
  message: string;
}

export default function Indicator({ pullDistance, pullState, threshold, message }: IndicatorProps) {
  const opacity = Math.min(pullDistance / threshold, 1);
  const scale = 0.8 + Math.min(pullDistance / threshold, 1) * 0.2;
  const rotation = pullState === "ready" ? 180 : pullDistance * 2;

  // Don't show indicator when idle and no pull distance
  if (pullState === "idle" && pullDistance === 0) {
    return null;
  }

  return (
    <div
      className={styles.indicator}
      style={{
        opacity,
        transform: `translateY(${pullDistance - 50}px) scale(${scale})`,
        transition: pullState === "returning" ? "all 0.3s ease" : "none",
      }}
    >
      <div className={styles.indicatorContent}>
        <div
          className={styles.icon}
          style={{
            transform: `rotate(${pullState === "refreshing" ? 0 : rotation}deg)`,
            animation: pullState === "refreshing" ? "spin 0.8s linear infinite" : "none",
          }}
        >
          {pullState === "refreshing" ? (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M4 12a8 8 0 018-8V2.5M12 4a8 8 0 018 8h1.5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M20 12a8 8 0 01-8 8v1.5M12 20a8 8 0 01-8-8H2.5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 5v14M12 19l-7-7m7 7l7-7"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </div>
        <span className={styles.text}>{message}</span>
      </div>
    </div>
  );
}